// extracted by mini-css-extract-plugin
export default {"grid":"ProjectThumbnailsV6Grid_grid__lXY2d"};